import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { extractTableHeaders } from 'utils/hooks/reportTableUtils';
import { BProps, DataTypeB0201 } from 'store/ducks/Reportings/types';
import { columnsB0201 } from 'constants/reportColumns';

const B0201: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0201[]>([]);
  const memoizedColumns = useMemo(() => columnsB0201, [columnsB0201]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchRT0201(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            annual_expense: dataItem.annual_expense,
            arrangement_reference_number: dataItem.arrangement_reference_number,
            contract_type: dataItem.contract_type,
            currency: dataItem.currency,
            overarching_reference_number: dataItem.overarching_reference_number,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  useEffect(() => {
    extractTableHeaders(memoizedColumns, dispatch);
  }, []);

  return (
    <>
      <Table
        columns={columnsB0201}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0201;
